import "core-js/stable";
import "./css/main.css"
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css';
import {setCookie, getCookie, cookieAccept, cookieClose, cookieInit} from './libs/cookie';
import {backToTop, scrollDown, setBoxHeight,setHaderHeight, menuTrigger, initAnchorLinks, sublayerAction, ismobile} from './libs/utils'
import * as Animations from "./libs/scenes";

var imagesLoaded = require('imagesloaded');

window.$ = $;

window.addEventListener("orientationchange", function() {
  let deg = parseInt(window.orientation, 10);
  if (deg != 0 && ismobile()) {
    $('.device').addClass('device--show');
  }  else {
    $('.device').removeClass('device--show');
  }
});

window.addEventListener("load", function(){
  imagesLoaded(document.querySelector('.header'), {background: true}, () => {
     Animations.init();
  })
})

$(function () {
  
    sublayerAction()
    initAnchorLinks();
    menuTrigger();
    cookieClose();
    cookieAccept();
    cookieInit();
    scrollDown();
    backToTop();

    /* MENU */
    Animations.menuScrollToggle()

    // inizializzo le animazioni
    Animations.general();
   
})

